function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 22,
  height: 19,
  rx: 3.5,
  fill: "#F8F9FB"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 22,
  height: 19,
  rx: 3.5,
  stroke: "#404040"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M11.0225 14.0977C10.5309 14.0977 10.0947 14.0146 9.71387 13.8486C9.33301 13.6794 9.0319 13.445 8.81055 13.1455C8.58919 12.846 8.47201 12.4993 8.45898 12.1055H9.5625C9.57878 12.3203 9.65202 12.5059 9.78223 12.6621C9.91243 12.8184 10.0833 12.9404 10.2949 13.0283C10.5098 13.113 10.749 13.1553 11.0127 13.1553C11.2992 13.1553 11.5531 13.1048 11.7744 13.0039C11.9958 12.903 12.1683 12.7646 12.292 12.5889C12.4189 12.4098 12.4824 12.2031 12.4824 11.9688C12.4824 11.7246 12.4206 11.5098 12.2969 11.3242C12.1732 11.1354 11.9925 10.9889 11.7549 10.8848C11.5173 10.7806 11.2308 10.7285 10.8955 10.7285H10.2754V9.83008H10.8955C11.1624 9.83008 11.3984 9.78125 11.6035 9.68359C11.8086 9.58594 11.9681 9.45085 12.082 9.27832C12.1992 9.10579 12.2578 8.90234 12.2578 8.66797C12.2578 8.44336 12.2074 8.24805 12.1064 8.08203C12.0055 7.91276 11.8639 7.78255 11.6816 7.69141C11.4993 7.59701 11.2845 7.5498 11.0371 7.5498C10.7995 7.5498 10.5781 7.59212 10.373 7.67676C10.168 7.76139 10.0003 7.88346 9.87012 8.04297C9.74316 8.19922 9.67643 8.38965 9.66992 8.61426H8.61035C8.62012 8.22038 8.73405 7.87533 8.95215 7.5791C9.1735 7.27962 9.46647 7.04688 9.83105 6.88086C10.1989 6.71159 10.6058 6.62695 11.0518 6.62695C11.5173 6.62695 11.9193 6.7181 12.2578 6.90039C12.5996 7.07943 12.8633 7.32031 13.0488 7.62305C13.2344 7.92253 13.3271 8.24967 13.3271 8.60449C13.3271 9.0179 13.2132 9.36621 12.9854 9.64941C12.7575 9.92936 12.4531 10.1198 12.0723 10.2207V10.2744C12.554 10.3493 12.9268 10.5413 13.1904 10.8506C13.4574 11.1598 13.5908 11.5439 13.5908 12.0029C13.5908 12.4033 13.4785 12.7614 13.2539 13.0771C13.0326 13.3929 12.7282 13.6419 12.3408 13.8242C11.9567 14.0065 11.5173 14.0977 11.0225 14.0977Z",
  fill: "#404040"
});

function SvgStep3Icon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep3Icon);
export default __webpack_public_path__ + "static/media/step3Icon.30fdd946.svg";
export { ForwardRef as ReactComponent };